module.exports = {
	"base": {
		"welcome": "%{name} 님, Mulligans에 오신 것을 환영합니다!",
		"user": "사용자 정보",
		"devices": "기기",
		"refunds": "환불",
		"resources": "리소스",
		"transactions": "주문 및 반품",
		"email": "이메일",
		"password": "암호",
		"save": "저장",
		"sign-out": "로그아웃",
		"cancel": "취소",
		"close": "닫기",
		"learn-more": "자세히 알아보기",
		"required": "필수",
		"support": "지원",
		"bookshelf": "책장",
		"launch": "시작",
		"download": "다운로드",
		"details": "세부 정보",
		"cannot-be-blank": "%{field} 필드는 비워 둘 수 없습니다.",
		"saving": "저장 중...",
		"done": "완료",
		"failed": "실패",
		"copy": "복사"
	},
	"signin": {
		"login-failure": "이메일 또는 암호가 올바르지 않습니다.",
		"welcome-large": "<span class='inner'>%{brand} Account Center</span>에 오신 것을 환영합니다.",
		"welcome-small": "<span class='inner'>Account Center</span>",
		"signin-button": "로그인",
		"forgot-password": "암호를 잊어버리셨나요?",
		"new-to-vst": "%{brand}에 처음이신가요?",
		"create-account": "계정 만들기",
		"signing-in": "로그인 중...",
		"signin-failed": "로그인 실패"
	},
	"transactions": {
		"price": "가격",
		"excluded": "(세금 포함)",
		"quantity": "양",
		"confirmation#": "확인 번호",
		"payment": "지불",
		"purchased": "구입함",
		"purchase-details": "구입 세부 정보",
		"subtotal": "소계",
		"total": "총계",
		"tax": "세금",
		"loading": "많이 이용해 주셔서 감사합니다! 구입 내역을 로드하는 중입니다...",
		"no-purchases": "구입 내역이 없습니다.",
		"seller-vat": "판매자 부가가치세",
		"total-vat": "총 %{vat} 지불액",
		"portion": "%{subTax} 세금 %{rate}%",
		"vat-disclosure": "%{vat} 포함 가격",
		"purchases": "구입",
		"refunded-items": "환불된 항목",
		"book-title": "책 제목",
		"refund-details": "환불 세부 정보",
		"print-receipt": "영수증 인쇄",
		"request-refund": "환불 요청",
		"expired": "만료됨",
		"expires-in": "%{date}에 만료",
		"details-refund": "세부정보 및 환불",
		"modal": {
			"cant-refund-title": "환불 불가",
			"cant-refund": "다음 이유 중 하나 이상에 해당되므로 책을 환불할 수 없습니다.",
			"cant-refund-1": "책의 상당 분량을 이미 읽었습니다.",
			"cant-refund-2": "구입 일자로부터 14일을 초과했습니다.",
			"cant-refund-3": "온라인 리소스 코드가 표시되었습니다.",
			"cant-refund-4": "책이 이미 이전에 환불되었습니다.",
			"cant-refund-5": "모든 코드가 이미 사용 또는 환불되었습니다.",
			"cant-refund-6": "구입 일자로부터 30일을 초과했습니다.",
			"cant-refund-support": "%{brand}의 환불 정책에 대해 문의사항이 있으시면 <a href='%{support_url}' target='_blank'>지원 팀</a>에 문의하세요."
		},
		"license": {
			"perpetual": "온라인 이용 권한이 만료되지 않습니다.",
			"days": "%{days}일 액세스"
		}
	},
	"devices": {
		"description": "<span>%{desktop}</span>대의 컴퓨터와 <span>%{mobile}</span>대의 모바일/태블릿 기기에서%{brand}을(를) 항상 이용할 수 있습니다.",
		"loading": "회원님의 장치를 가져오는 중입니다.",
		"no-active": "활성화된 장치가 없습니다.",
		"deactivate": "비활성화"
	},
	"user": {
		"personal-information": "개인 정보",
		"security-information": "보안 정보",
		"notifications": "알림",
		"first-name": "이름",
		"last-name": "성",
		"change-password-title": "암호 변경",
		"current-password": "현재 암호",
		"new-password": "새 암호",
		"security-password": "암호",
		"confirm-new-password": "새 암호 확인",
		"security-question": "보안 질문",
		"security-info-change": "변경",
		"question": "질문",
		"answer": "답변",
		"notifications-text": "계정 활동, 제품 업데이트 및 특별 제공 서비스 등에 관한 업데이트 정보를 가끔 이메일로 보내 주세요.",
		"loading": "Spot이 회원님의 사용자 정보를 가져오는 중입니다. 잠시만 기다려 주세요. 🐶",
		"change-password-text": "암호는 대소문자 및 특수 문자를 조합한 8자 이상의 문자여야 합니다.",
		"email-locked": "잠긴 이메일",
		"email-locked-description": "이메일 변경에 대한 액세스 권한이 없습니다.",
		"email-locked-more": "관리자에게 문의하세요.",
		"security-question6": "어떤 스포츠를 가장 좋아하시나요?",
		"security-question7": "어떤 맛의 아이스크림을 가장 좋아하시나요?",
		"security-question8": "가장 좋아하는 애완 동물의 이름은 무엇인가요?",
		"security-question9": "어린 시절 장래 희망은 무엇이었나요?",
		"security-question10": "가장 좋아하는 선생님의 성함은 무엇인가요?",
		"new-password-failure": "암호가 기준에 맞지 않습니다.",
		"confirm-password-failure": "암호가 일치해야 합니다.",
		"new-password-tooltip": "대소문자 및 특수 문자를 조합한 8자 이상의 문자를 포함해야 합니다.",
		"enter-valid-email": "올바른 이메일을 입력하세요.",
		"password-cannot-be-same": "이전 암호와 동일한 암호를 사용할 수 없습니다.",
		"incorrect-password": "잘못된 암호",
		"complete-account": "<a href='%{href}'>계정을 완료</a>해야 할 것 같습니다.",
		"completing-allows": "계정을 완료하면 모바일 앱에서 오프라인으로 책을 읽고 노트와 하이라이트를 친구들과 공유할 수 있습니다.",
		"error-updating-info": "There was an error updating your information.",
		"password-updated": "Password successfully updated",
		"security-updated": "Security question successfully updated",
		"info-updated": "User information successfully updated"
	},
	"resources": {
		"ancillaries": "보조 리소스",
		"access-codes": "액세스 코드",
		"print-on-demand": "요청 시 인쇄",
		"check-pod": "책의 출판사 인쇄 옵션을 확인하십시오.",
		"check-now": "지금 확인",
		"loading": "리소스를 업데이트하는 중입니다. 잠시만 기다려 주세요!",
		"in": "위치:",
		"access-code-intro": "액세스 코드는 온라인으로 코스 콘텐츠에 액세스하는 데 사용하는 암호입니다. 항목에 대한 코드가 표시되면 되돌릴 수 없습니다. 액세스 코드 사용 방법에 대한 자세한 지침은 <a href='%{support_url}' target='_blank'>지원 팀</a>에 문의하세요.",
		"expires": "만료",
		"expiration-message": "액세스 코드 사용에 대한 지침이 포함되어 있습니다.",
		"copy-fail": "복사할 수 없습니다. 코드를 선택하고 수동으로 복사하세요.",
		"launch-site": "사이트 시작",
		"launch-book": "책 시작",
		"reveal-code": "코드 표시",
		"no-resources": "리소스가 없습니다.",
		"no-access-codes": "액세스 코드가 없습니다.",
		"no-ancillaries": "이 제목에 대한 보충 설명이 없음",
		"name": "이름",
		"type": "유형",
		"size": "크기",
		"download-all": "모두 다운로드",
		"back": "리소스로 돌아가기"
	},
	"refunds": {
		"states": {
			"refunded": "환불됨",
			"unavailable": "환불 불가"
		},
		"reasons": {
			"dropped": "코스를 중단했습니다.",
			"wrong": "코스에 해당되지 않는 책입니다.",
			"print": "인쇄본을 구입하려고 합니다.",
			"missing": "코스에 필요한 사항(예: CD, 웹 액세스 권한, 동영상) 일부가 책에 없습니다.",
			"other": "기타"
		},
		"bulk": {
			"policy": "아래의 '환불 완료' 버튼을 클릭하면 %{brand}의 <a href='%{policy_url}' target='_blank'>환불 정책</a>에 동의한 것으로 간주됩니다.",
			"complete": "환불 완료",
			"view-details": "환불 세부 정보 보기",
			"success": "환불이 요청되었습니다. 처리되기까지 48시간이 걸립니다.",
			"failure": "죄송합니다. 문제가 발생했습니다! 환불이 처리되지 않았습니다.",
			"retry": "다시 시도",
			"support": "지원부 연락",
			"available-codes": "사용 가능한 코드",
			"codes-selected": "선택한 코드",
			"download": "코드 다운로드",
			"partially-refunded": "일부 환불됨",
			"pick-one": "환불하려면 하나 이상의 코드를 선택해야 합니다."
		},
		"refund": "환불",
		"all": "모두 환불하시겠습니까?",
		"missing-reason": "계속하려면 사유를 선택해야 합니다.",
		"missing-elaboration": "자세히 설명해 주십시오.",
		"policy": "아래의 “환불 요청 완료” 버튼을 클릭하면 이 %{brand} eTextbook을 다시 구입하는 경우 동일한 eTextbook에 대해 추가 환불을 요청할 수 없음을 이해한 것으로 간주합니다. 전체 환불 규정을 확인하세요.",
		"refunded": "환불됨",
		"sorry": "구입하신 상품이 만족스럽지 못한 점에 대해 사과드립니다.",
		"error": "오류가 발생했습니다.",
		"error-explain": "환불을 처리할 수 없습니다. 다시 시도해 주세요.",
		"why": "이유를 알려주세요.",
		"no-refunds": "환불된 상품이 없습니다.",
		"select-codes": "환불할 코드 선택:",
		"number": "환불 건수",
		"back": "환불로 돌아가기"
	},
	"purchases": {
		"back": "구입으로 돌아가기"
	},
	"global-bar": {
		"account": "계정 설정"
	}
};


/*****************
 ** WEBPACK FOOTER
 ** ./src/locales/ko.json
 ** module id = 1015
 ** module chunks = 0
 **/